import React from 'react'
import styled from 'styled-components'

const Icon = styled.img`
  position: absolute;
  top: -8px;
  right: -8px;
`

const Type = ({ type }) => {
  switch (type) {
    case 'employment':
    case 'work':
      return <Icon src={'/icons/work.svg'} alt="" />
    case 'interest':
      return <Icon src={'/icons/interest.svg'} alt="" />
    case 'hobby':
      return <Icon src={'/icons/hobby.svg'} alt="" />
    case 'education':
      return <Icon src={'/icons/education.svg'} alt="" />
    default:
      return null
  }
}

export default Type



// WEBPACK FOOTER //
// ./src/components/ConsultantList/Consultant/Relevance/Type.js